import {lazy} from '@aboutyou/lazy-imports';
import {useLogHydrationFailed} from '@aboutyou/logic-components';
import React from 'react';
import {CategorySkeleton} from './CategorySkeleton';

const LoadingSkeletonWithHydrationFailedLogging: React.FC = () => {
  useLogHydrationFailed({context: 'CategoryPageSkeleton'});
  return <CategorySkeleton />;
};

export const Category = lazy(
  () => import('./Category.eager').then(mod => ({default: mod.Category})),
  {
    fallback: <LoadingSkeletonWithHydrationFailedLogging />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
